import React from "react";
import styled, { keyframes } from "styled-components";

const dashFrames = keyframes`
  62.5% {
    opacity: 0;
  }
  to {
    stroke-dashoffset: 0;
  }
`;
const StyledIndicator = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  height: 160px;
  width: 160px;
  background-color: #de8538;
  border-radius: 100%;
  overflow: hidden;

  svg {
    transform: scale(1.1);
  }
  polyline.loadingSpinnerBack {
    stroke: #fff;
  }
  polyline.loadingSpinnerFront {
    animation: ${dashFrames} 1s linear infinite;
    stroke: #999;
    stroke-dasharray: 12, 36;
    stroke-dashoffset: 48;
  }
`;

const LoadingSpinner = () => (
  <StyledIndicator>
    <svg className="svg" width="160px" height="160px" viewBox="0 0 16 12">
      <polyline
        className="loadingSpinnerBack"
        points="1 6 4 6 6 11 10 1 12 6 15 6"
      />
      <polyline
        className="loadingSpinnerFront"
        points="1 6 4 6 6 11 10 1 12 6 15 6"
      />
    </svg>
  </StyledIndicator>
);

export default LoadingSpinner;
